// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FlaskBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.144 24.714 20.5 11.976V5.5h.5a1.5 1.5 0 0 0 0-3H11a1.5 1.5 0 0 0 0 3h.5v6.476L3.856 24.714A2.5 2.5 0 0 0 6 28.5h20a2.5 2.5 0 0 0 2.144-3.786ZM17.5 5.5v6.893c0 .271.074.538.214.77l4.391 7.318c-1.349.108-3.144-.164-5.428-1.32-1.75-.885-3.432-1.416-5.033-1.595l2.642-4.402a1.5 1.5 0 0 0 .214-.771V5.5h3Zm-10.618 20 2.993-4.976c1.625-.139 3.453.302 5.453 1.315 2.45 1.24 4.53 1.664 6.23 1.664a9.43 9.43 0 0 0 2.206-.253l1.354 2.25H6.881Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
